


























import { MxFun } from "mxdraw";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "ObjectActionBar",
})

export default class ObjectActionBar extends Vue {
    @Prop({
        type: Boolean,
        default: false
    }) isShow!: boolean

    isShowColors = false
    colors = ['red', 'yellow', 'blue']
    setColor(color:string) {
        // 设置颜色
        MxFun.sendStringToExecute("BR_SetEntityColor",color);
    }
    copyObj() {
        // 复制对象
        MxFun.sendStringToExecute("BR_CopyEntity");
    }
    deleteObj() {
        // 删除对象
        MxFun.sendStringToExecute("BR_DeleteEntity");
       
    }
    
}
